const getters = {
  userInfo: state => state.user.userInfo,
  token: state => state.user.token,
  globalVip: state => state.user.globalVip,
  homeScrollTop: state => state.common.homeScrollTop,
  source: state => state.common.source,
  timer: state => state.common.timer, // 评论倒计时
  showCourseDetailServe: state => state.common.showCourseDetailServe, //显示精品课详情客服按钮
  showCampDetailServe: state => state.common.showCampDetailServe, //显示精品课详情客服按钮
  showQcode: state => state.common.showQcode
}

export default getters
